// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { History as RawHistory } from "lucide-react";
export const History = /* @__PURE__ */ createIcon(RawHistory, "History", 2);
